export default {"src":"/_next/static/media/vet.0b0a6b72.svg","height":293,"width":253};